import React from "react";
import { SyncContext, SyncContextType } from "./Contexts/BatchSyncContext";

// ProtectedRoute component to handle route protection based on user authentication and permissions
class ProtectedRoute extends React.Component<{ children: React.ReactNode }> {
    static contextType = SyncContext;
    context!: SyncContextType;

    render() {
        const { state } = this.context;
        const { children } = this.props;
        const { email, permissions } = state; // Extract global state values
        const location = window.location.pathname; // Get the current route

        // Redirect to login if not authenticated
        if (!permissions) {
            localStorage.clear();
            localStorage.removeItem("batch-info");
            window.location.href = "/";
            return null;
        }

        // Define permitted routes based on permissions
        const allowedRoutes: Record<string, boolean> = {
            "/dashboard": permissions.dashboard?.isVisible,
            "/transactionlogs": permissions.transactionLogs?.isVisible,
            "/compliance": permissions.complianceLogs?.isVisible,
            "/userdetails": permissions.userDetails?.isVisible,
            "/userreports": permissions.userTransactionReport?.isVisible,
            "/useractions": permissions.userLogs?.isVisible,
            "/promocode": permissions.promoCode?.isVisible,
            "/exchangerate": permissions.exchangeRates?.isVisible,
            "/referral": permissions.referrals?.isVisible,
            "/chargeback": permissions.chargeBack?.isVisible,
            "/partner": permissions.partner?.isVisible,
            "/fxreports": permissions.fxReports?.isVisible,
            "/fxpools": permissions.fxAllocation?.isVisible,
            "/fxallocations": permissions.fxAllocation?.isVisible,
            "/fxpooldetails": permissions.fxAllocation?.isVisible,
        };

        const currentURL = window.location.href;

        // Check if the URL contains "/userdetails" with an email parameter
        const urlObj = new URL(currentURL);
        const pathname = urlObj.pathname;
        const hasEmailParam = urlObj.searchParams.has("email");

        if (pathname.includes("/userdetails") && hasEmailParam) {
            localStorage.setItem("redirectAfterLogin", currentURL);
        } else if (localStorage.getItem("redirectAfterLogin")) {
            localStorage.removeItem("redirectAfterLogin");
        }


        // Check if the user is attempting to access an unauthorized route
        if (!allowedRoutes[location]) {
            //localStorage.clear();
            this.context.dispatch({ type: "RESET_STATE" });
            return window.location.href = "/";
        }

        return children; // Render the requested route if access is allowed
    }
}

export default ProtectedRoute;